import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Home, CircleDollarSign, Banknote } from 'lucide-react';
import { Button } from './Button';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const imageVariants = {
  hidden: {
    opacity: 0,
    x: 50
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function CalculatorCTA() {
  return <section className="w-full bg-white py-20 px-4 overflow-hidden" data-id="element-29">
      <div className="max-w-7xl mx-auto" data-id="element-30">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-stretch" data-id="element-31">
          {/* Left Column: Content */}
          <motion.div className="flex flex-col" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-32">
            <motion.h2 variants={itemVariants} className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#07493a] font-[500] mb-8 leading-tight" data-id="element-33">
              Find out how much wealth is tied up in your home equity
            </motion.h2>

            <motion.div variants={itemVariants} className="bg-[#f5ecd4] rounded-2xl p-8 md:p-10 flex-1 flex flex-col" data-id="element-34">
              <p className="text-xl md:text-2xl font-serif text-[#07493a] mb-8 leading-relaxed font-[500]" data-id="element-35">
                Get a quick online estimation of how much equity you could
                unlock using our calculator.
              </p>

              <div className="mb-10" data-id="element-36">
                <Button variant="primary" size="lg" href="/calculator" data-id="element-37">
                  Get an estimate
                </Button>
              </div>

              <div className="space-y-8 mt-auto" data-id="element-38">
                {/* Benefit 1 */}
                <div className="flex items-start" data-id="element-39">
                  <div className="w-12 h-12 rounded-full bg-[#e8dbb8] flex items-center justify-center flex-shrink-0 mr-4" data-id="element-40">
                    <CircleDollarSign className="w-6 h-6 text-[#07493a]" strokeWidth={1.5} data-id="element-41" />
                  </div>
                  <div data-id="element-42">
                    <h4 className="text-[#07493a] font-bold text-lg mb-1" data-id="element-43">
                      Access up to 75% of your home value
                    </h4>
                    <p className="text-[#07493a]/80" data-id="element-44">Proceeds are tax free.</p>
                  </div>
                </div>

                {/* Benefit 2 */}
                <div className="flex items-start" data-id="element-45">
                  <div className="w-12 h-12 rounded-full bg-[#e8dbb8] flex items-center justify-center flex-shrink-0 mr-4" data-id="element-46">
                    <Banknote className="w-6 h-6 text-[#07493a]" strokeWidth={1.5} data-id="element-47" />
                  </div>
                  <div data-id="element-48">
                    <h4 className="text-[#07493a] font-bold text-lg mb-1" data-id="element-49">
                      No regular payments required
                    </h4>
                    <p className="text-[#07493a]/80" data-id="element-50">
                      Making interest payments is up to you.
                    </p>
                  </div>
                </div>

                {/* Benefit 3 */}
                <div className="flex items-start" data-id="element-51">
                  <div className="w-12 h-12 rounded-full bg-[#e8dbb8] flex items-center justify-center flex-shrink-0 mr-4" data-id="element-52">
                    <Home className="w-6 h-6 text-[#07493a]" strokeWidth={1.5} data-id="element-53" />
                  </div>
                  <div data-id="element-54">
                    <h4 className="text-[#07493a] font-bold text-lg mb-1" data-id="element-55">
                      Maintain 100% ownership
                    </h4>
                    <p className="text-[#07493a]/80" data-id="element-56">
                      Stay in the home you love.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div className="h-full w-full min-h-[400px] lg:min-h-[600px]" variants={imageVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-50px'
        }} data-id="element-57">
            <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=80" alt="Beautiful Ontario suburban home with brick exterior" className="w-full h-full object-cover rounded-3xl shadow-xl" data-id="element-58" />
          </motion.div>
        </div>
      </div>
    </section>;
}